import { Box, styled } from '@mui/material';

const RelativeBox = styled(Box)({
  position: 'relative',
  height: 70,
  marginTop: 20,
});

const Scheme = styled(Box)({
  position: 'absolute',
  margin: 3,
  width: 'calc(100% - 2px)',
  height: 40,
});

const Anomaly = styled('div')({
  cursor: 'pointer',
  minWidth: '.25%',
  position: 'absolute',
  top: 3,
  height: 40,
  backgroundColor: '#e42519',
  opacity: 0.2,
  '&:hover': {
    opacity: 1,
  },
});

const Timeline = styled('input')(({ theme }) => ({
  WebkitAppearance: 'none',
  width: '100%',
  height: 42,
  border: `1px solid ${theme.palette.grey[600]}`,
  backgroundColor: theme.palette.grey[500],
  '&:focus': {
    outline: 'none',
  },
  '&::-webkit-slider-thumb': {
    WebkitAppearance: 'none',
    cursor: 'pointer',
    width: 2,
    height: 40,
    backgroundColor: '#000',
  },
  zIndex: 99,
}));

export { Timeline, Anomaly, RelativeBox, Scheme };
